var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style.alert] = true, _obj[_vm.$style.warning] = _vm.warning, _obj[_vm.$style.info] = _vm.info, _obj[_vm.$style.success] = _vm.success, _obj )},[_c('SmallIcon',{attrs:{"icon":_vm.icon,"size":"sm"}}),_vm._v(" "+_vm._s(_vm.message)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }